import { useDispatch } from "react-redux";
import {QuotationRecordService} from "../../../../services";
import {showErrorToast, showSuccessToast} from "../../../../state/toasts";

export const useEstimation = (ticket, onUpdate, onClose) => {
  const dispatch = useDispatch();

  const createEstimation = async (data: Record<string, any>) => {
    const payload = { ...data, ticket: ticket.url };

    try {
      const response = await new QuotationRecordService().makePostRequest(payload);
      onUpdate({
        ...ticket,
        quotation_records: [...ticket.quotation_records, response],
      });
      dispatch(showSuccessToast("Success", "Item added successfully"));
      onClose?.();
    } catch (error: any) {
      dispatch(showErrorToast("Error", error?.response?.data || "Unknown error occurred"));
    }
  };

  return { createEstimation };
};
